export default __webpack_public_path__ + "static/analysts_Architect_INTJ_parenthood-ed1e88a4ac127c0fc4b6648b1396828e.svg";